/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Reaction } from './Reaction';
import {
    ReactionFromJSON,
    ReactionFromJSONTyped,
    ReactionToJSON,
} from './Reaction';

/**
 * 
 * @export
 * @interface Reactions
 */
export interface Reactions {
    /**
     * 
     * @type {Array<Reaction>}
     * @memberof Reactions
     */
    data?: Array<Reaction>;
}

/**
 * Check if a given object implements the Reactions interface.
 */
export function instanceOfReactions(value: object): value is Reactions {
    let isInstance = true;

    return isInstance;
}

export function ReactionsFromJSON(json: any): Reactions {
    return ReactionsFromJSONTyped(json, false);
}

export function ReactionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): Reactions {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(ReactionFromJSON)),
    };
}

export function ReactionsToJSON(value?: Reactions | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(ReactionToJSON)),
    };
}

